/**
 * Página de Erro 403 - Acesso não permitido
 * Fidelidade visual pixel-perfect com o original Rails
 */
import { useTranslation } from 'react-i18next';

export function Error403Page() {
  const { t } = useTranslation();
  return (
    <div className="text-center w-full mt-[100px]">
      <div className="text-[68px]">{t('views.errors.oops', 'Ops!')}</div>
      <div className="text-[22px]">
        {t('views.errors.forbidden', 'Não conseguimos localizar a página desejada ou você não tem acesso :(')}
      </div>
    </div>
  );
}
